import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {StorageService} from '../service/storage.service';
import {navigationUrlForLogin} from '../service/navigation-urls';

export const validJwtGuard = (): CanActivateFn => {
   return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
       const storageService = inject(StorageService);
       const router = inject(Router);
       const accessToken = storageService.getAccessToken();
       if (accessToken) {
           return true;
       }
       console.log("---invalid session token---");
       return router.navigate(navigationUrlForLogin());
   }
}
